import { FC, JSX, PropsWithChildren, ReactNode } from 'react'

import { LocalizableProvider } from '@contexts/LocalizableContext'
import { Input, InputType } from './Input'
import { LangSelector, LangSelectorType } from './LangSelector'
import { Render, RenderType } from './Render'
import { TextArea, TextAreaType } from './TextArea'
import { LocalizedTextEditor, LocalizedTextEditorType } from './TextEditor'

interface LocalizableProps {
  children: ReactNode
  /**
   * This surface renders the language selector in its own header, so the fields
   * below must not render one each. See `LocalizableProvider`.
   */
  headerSelector?: boolean
}

export const Localizable: FC<PropsWithChildren<LocalizableProps>> &
  InputType &
  TextAreaType &
  RenderType &
  LocalizedTextEditorType &
  LangSelectorType = ({ children, headerSelector }): JSX.Element => (
  <LocalizableProvider headerSelector={headerSelector}>
    {children}
  </LocalizableProvider>
)

Localizable.Input = Input
Localizable.Render = Render
Localizable.TextArea = TextArea
Localizable.TextEditor = LocalizedTextEditor
Localizable.LangSelector = LangSelector
